import { translations } from './translations/i18n';
import { writable, get } from 'svelte/store';
let lang = "fr";
const urlParams = new URLSearchParams(window.location.search);
if (urlParams.has("lang")) {
    lang = urlParams.get("lang");
}
const translationStore = writable(translations[lang]);
export const translation = get(translationStore);
